import styled from "styled-components";
import device from 'utils/device'
import { Atom } from 'AppReact';

const template = styled.div`
  font-size: 16px;
  color: ${window?.settings?.secondary_color ?? '#04333b'};
  text-align: center;
  @media ${device.tablet} {
    font-weight: 500;
    font-size: 32px;
    line-height: 38px;
  }
`;

export default Atom({ type: 'label', dataType: 'string', template })